import { render, staticRenderFns } from "./BundleBuyButton.vue?vue&type=template&id=6ae6d07b&scoped=true&"
import script from "./BundleBuyButton.vue?vue&type=script&lang=js&"
export * from "./BundleBuyButton.vue?vue&type=script&lang=js&"
import style0 from "./BundleBuyButton.vue?vue&type=style&index=0&id=6ae6d07b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae6d07b",
  null
  
)

export default component.exports